<template>
  <div>
    <div :class="MenuVisible ? 'visible' : 'oculto'">
      <div style="height:80px"></div>
      <b-navbar fixed="top" class="px-4" toggleable="lg" type="dark" variant="primary">
        <b-navbar-brand @click="enrutar('/')">
          <img width="200" src="/logo3.svg" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="mx-auto"> </b-navbar-nav>

          <!-- Right aligned nav items -->

          <b-navbar-nav v-if="isUsuario">
            <b-nav-item @click="enrutar('/courier/envios')"> <b-icon icon="briefcase"></b-icon> Envios </b-nav-item>
            <b-nav-item @click="enrutar('/courier/clientes')"> <b-icon icon="person-square"></b-icon> Clientes </b-nav-item>
            <b-nav-item @click="enrutar('/courier/productos')"> <b-icon icon="shop"></b-icon> Productos </b-nav-item>
            <b-nav-item @click="enrutar('/courier/reportes')"> <b-icon icon="journal"></b-icon> Reportes </b-nav-item>
            <b-nav-item @click="enrutar('/courier/region')"> <b-icon icon="geo-alt"></b-icon> Region </b-nav-item>

            <b-nav-item @click="enrutar('/courier/configuracion')"> <b-icon icon="gear"></b-icon> Configuracion </b-nav-item>

            <b-nav-item @click="salir"> <b-icon icon="box-arrow-left" /> Salir</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav v-else>
            <b-nav-item @click="enrutar('/')"> <b-icon icon="house" /> Inicio</b-nav-item>
            <b-nav-item @click="enrutar('/nosotros')"> <b-icon icon="building" /> Nosotros</b-nav-item>
            <b-nav-item @click="enrutar('/servicios')"> <b-icon icon="info-circle" /> Servicios</b-nav-item>
            <b-nav-item @click="enrutar('/contacto')"> <b-icon icon="telephone-forward" /> Contacto</b-nav-item>
            
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  beforeCreate() {
    this.$root.$on("Imprimir", (v) => {
      this.MenuVisible = !v.ok;
    });
  },
  mounted() {
    this.$root.$on("EstadoUsuario", (v) => {
      this.isUsuario = v;
    });
  },
  created() {
    this.isUsuario = this.$session.exists();
  },
  data() {
    return { isUsuario: false, MenuVisible: true };
  },
  methods: {
    enrutar(direccion) {
      event.preventDefault();
      this.$router.push(direccion);
    },
    salir() {
      this.$session.destroy();
      this.isUsuario = false;
      this.$router.push("/ingresar");
    },
  },
};
</script>

<style scoped>
.bg-primary {
  background-color: #26599c !important;
}

.mt-6 {
  margin-top: 86px;
  padding: 0px 10px;
}
.oculto {
  display: none;
}
.visible {
  display: block;
}
</style>
